import React from 'react';
import { Star, Quote } from 'lucide-react';
import { CircuitPaths, CharReveal, TiltCard, Reveal } from './TerminalEffects';

const reviews = [
  { id: 'review-sarah-mitchell', name: 'Sarah Mitchell', role: 'Owner, Mitchell Dental Practice', rating: 5, text: "HiBotics AI has completely transformed how we handle patient calls. We've gone from missing 15-20 calls per week to zero. The AI receptionist is always professional, and our patients love the 24/7 booking availability.", image: 'https://images.unsplash.com/photo-1655249481446-25d575f1c054?w=200&h=200&fit=crop&crop=face' },
  { id: 'review-james-rodriguez', name: 'James Rodriguez', role: 'Real Estate Agent, Premier Properties', rating: 5, text: "As a solo agent, I was constantly juggling calls while showing properties. The AI voice agent qualifies leads, schedules viewings, and follows up with prospects. It's like having a full-time assistant at a fraction of the cost.", image: 'https://images.unsplash.com/photo-1651684215020-f7a5b6610f23?w=200&h=200&fit=crop&crop=face' },
  { id: 'review-emma-thompson', name: 'Emma Thompson', role: 'Manager, The Wellness Studio', rating: 5, text: "Our boutique fitness studio saw a 40% increase in class bookings after implementing HiBotics AI. The chatbot handles memberships, class schedules, and even sends reminders.", image: 'https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?w=200&h=200&fit=crop&crop=face' },
  { id: 'review-craig-barker', name: 'Craig Barker', role: 'Director, Irwin Mitchell Law', rating: 5, text: "The AI system screens potential clients efficiently while maintaining our firm's professional image. Our conversion rate has increased by 30% since implementation.", image: 'https://images.unsplash.com/photo-1769636930047-4478f12cf430?w=200&h=200&fit=crop&crop=face' },
  { id: 'review-lisa-patel', name: 'Lisa Patel', role: 'Owner, Serenity Spa & Beauty', rating: 5, text: "Managing appointments used to be chaos during peak hours. Now the AI chatbot handles everything. Our no-show rate dropped by 60%, and client satisfaction scores are at an all-time high!", image: 'https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?w=200&h=200&fit=crop&crop=face' },
];

const CARD_ACCENTS = ['#00FFD1', '#7DFFD4', '#7DFFD4', '#C4956A', '#7DFFD4'];

export const ReviewsSection = () => (
  <section id="reviews" className="relative py-28 bg-[#2A2A2A] overflow-hidden" data-testid="reviews-section">
    <CircuitPaths />
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10">
      <Reveal>
        <div className="mb-20 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-[600px]">
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A] mb-4">Client Reviews</p>
            <CharReveal text="Trusted by Business Owners" tag="h2"
              className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#F5F0E0] leading-[1.05]" />
          </div>
          <div className="flex items-center gap-3">
            <div className="flex -space-x-3">
              {reviews.slice(0, 4).map((r) => (
                <img key={r.id} src={r.image} alt="" className="w-10 h-10 rounded-full border-2 border-[#2A2A2A] object-cover" loading="lazy" />
              ))}
            </div>
            <p className="text-sm text-[#F5F0E0]/50"><span className="text-[#7DFFD4] font-semibold">50+</span> businesses trust us</p>
          </div>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((review, index) => (
          <Reveal key={review.id} delay={index * 120}>
            <TiltCard accentColor={CARD_ACCENTS[index]} className="h-full">
              <div className={`relative rounded-2xl p-8 h-full flex flex-col ${
                index === 0 ? 'bg-[#1A1A1A] border border-[#00FFD1]/20' :
                index === 3 ? 'bg-[#1A1A1A] border border-[#C4956A]/20' :
                'bg-[#1A1A1A]'
              }`} data-testid={`review-card-${index}`}>
                <Quote size={40} className="text-[#7DFFD4]/5 absolute top-6 right-6" />
                <div className="flex gap-0.5 mb-5">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={`${review.id}-star-${i}`} size={14} fill="#C4956A" className="text-[#C4956A]" />
                  ))}
                </div>
                <p className="text-sm text-[#F5F0E0]/70 mb-6 leading-relaxed flex-1" style={{ fontFamily: "'Manrope', sans-serif" }}>
                  "{review.text}"
                </p>
                <div className="pt-5 border-t border-[#F5F0E0]/10 flex items-center gap-3">
                  <img src={review.image} alt={review.name} className="w-11 h-11 rounded-full object-cover ring-2 ring-[#00FFD1]/20" loading="lazy" />
                  <div>
                    <h4 className="text-sm font-semibold text-[#F5F0E0]">{review.name}</h4>
                    <p className="text-xs text-[#F5F0E0]/40 mt-0.5">{review.role}</p>
                  </div>
                </div>
              </div>
            </TiltCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
